"use client";

import HeroSection from "@/components/frontend/home/HeroSection";
import PracticeAreas from "@/components/frontend/home/PracticeAreas";
import OurProcess from "@/components/frontend/home/OurProcess";
import BlogSection from "@/components/frontend/home/BlogSection";
import AboutSection2 from "@/components/frontend/home/AboutSection2";
import IntroSection from "@/components/frontend/home/IntroSection";
import TeamBanner from "@/components/frontend/home/TeamBanner";
import { ArrowRight } from "lucide-react";
import Link from "next/link";



export default function Home() {
  
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <HeroSection />
      <AboutSection2 />
      <IntroSection />
      <TeamBanner />
      <PracticeAreas />
      <OurProcess />
      {/* <BlogSection /> */}
      <div className="flex items-center justify-center w-full h-[400px] relative"
      style={{backgroundImage: "url('/images/office.jpg')", backgroundAttachment: "fixed",
        backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "no-repeat"}}>
        {/* overlay */}
        <div className="absolute inset-0 bg-primary/30" />

        {/* CTA container */}
        <div className="flex items-center justify-center w-[90%] md:w-[70%] lg:w-[60%] bg-white/50 
        backdrop-blur-sm py-10 px-6 md:px-16 lg:px-36 rounded-xl z-10 text-center">
          <div className="flex flex-col items-center gap-5">
            <h3 className="text-[22px] md:text-[30px] lg:text-[34px] text-primary uppercase font-lora
            font-bold">
              Ready to solve your case?
            </h3>

            <p className="text-base md:text-lg w-full md:w-[80%]">
              Our experts are prepared to dive in, understand your challenge, and deliver a clear path forward.
            </p>

            <Link href="/contact-us" className="flex items-center justify-center gap-3 px-5
            py-4 bg-secondary text-black text-lg rounded-md">
              Get in touch with us
              <ArrowRight />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
